import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  MemberRolesBySiteResponseDto,
  MemberRolesResponseDto,
  RoleDto,
} from '@services/api'
import {
  assignMemberRoles,
  createRole,
  deleteRoles,
  fetchMemberRoles,
  findAllRoles,
  updateRole,
} from '@state/thunks/roleThunk'

type roleState = {
  roles: RoleDto[]
  memberRoles: MemberRolesBySiteResponseDto | null
}

const initialState: roleState = {
  roles: [],
  memberRoles: null,
}

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    removeRoles: (state) => {
      state.roles = initialState.roles
    },
    removeMemberRoles: (state) => {
      state.memberRoles = null
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(
        findAllRoles.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          state.roles = payload
        },
      )
      .addCase(
        createRole.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          state.roles = [...state.roles, payload]
        },
      )
      .addCase(
        updateRole.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          const index = state.roles.findIndex((role) => role.id === payload.id)
          if (index !== -1) {
            state.roles[index] = payload
          }
        },
      )
      .addCase(
        deleteRoles.fulfilled,
        (state, { payload }: PayloadAction<any>) => {
          state.roles = state.roles.filter((role) => !payload.includes(role.id))
        },
      )
      .addCase(
        fetchMemberRoles.fulfilled,
        (state, { payload }: PayloadAction<MemberRolesBySiteResponseDto>) => {
          state.memberRoles = payload
        },
      )
      .addCase(assignMemberRoles.fulfilled, (state, action) => {
        if (!state.memberRoles) return

        // Use siteId from the request body as fallback when roles array is empty
        const siteId =
          action.payload.roles[0]?.siteId ?? action.meta.arg.body.siteId

        if (siteId == null) return

        const siteIndex = state.memberRoles.sites.findIndex(
          (s) => s.siteId === siteId,
        )

        if (siteIndex !== -1) {
          state.memberRoles.sites[siteIndex].roles = action.payload.roles
        }
      }),
})

export const { removeRoles, removeMemberRoles } = roleSlice.actions

export default roleSlice.reducer
